import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize, useFontSize } from "../../appTheme";
import { AppTheme } from "../../theme";

export const automaticDiscountListStyle = (theme: AppTheme) => StyleSheet.create({
    container: {
        flex: 1
    },
    view: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor
    },
    label: {
        color: appColors.labelColor,
        fontSize: fontSize?.smallFontSize,
    },
    iconStyle: {
        padding: 10,
        backgroundColor: appColors.lightBackgroundColor,
        borderRadius: 10,
        marginLeft: 10,
    },
    plusIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.primary,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    buttonFont: {
        fontSize: fontSize?.smallFontSize,
        fontFamily: appFonts?.bold,
        color: appColors?.light
    },
    deleteIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.red,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    badgeContainer: {
        justifyContent: 'center',
        marginLeft: 7
    },
    checkBoxText: {
        color: appColors.lightDark,
        fontSize: fontSize.smallFontSize,
        fontFamily: appFonts.medium
    },
    containerStyle: {
        marginTop: 10,
        marginHorizontal: 5
    },
    arrowStyle: {
        width: 0, height: 0
    },
    popoverStyle: {
        borderRadius: 10
    },
    renderTextStyle: {
        marginTop: 5
    },
    buttonView: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        gap: 10,
        margin: 10

    },
    subHeading: {
        fontSize: fontSize.largerFontSize,
        fontFamily: appFonts?.bold,
        color: appColors?.primary,
        marginVertical: 10
    },
    labelStyle: {
        fontSize: fontSize.smallerFontSize,
        color: appColors.labelColor
    },
    inputStyle: {
        fontSize: fontSize?.tinyFontSize,
        color: appColors?.dark,
        fontFamily: appFonts?.medium
    },
})